export const QUERYABLE_BUSINESS_ENTITY_STATUSES = [
  "active",
  "inactive",
] as const

export type QueryableBusinessEntityStatus =
  (typeof QUERYABLE_BUSINESS_ENTITY_STATUSES)[number]
